import React, {Component} from 'react'
import {Form, FormGroup, Label, Row, Col, Input, Button} from 'reactstrap'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import _ from 'lodash'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from 'react-toastify'

import updateClientMutation from '../../../queries/server/mutations/update_client_details'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_client'
import AUSelectGenerator from '../../components/auto_updaters/ValidSelect'

const AUSelectClientTypes = AUSelectGenerator('client_types', 'client_type_id description', 'client_type_id', ['description'])

class ClientDetailForm extends Component {


    constructor(props) {
        super(props)

        this.state = {
            ...this.props.client
        }

        this.save = _.debounce(this.save, 1000)
    }

    save = (data, serverMutation, localMutation) => {

        const {
            client_id,
            name,
            client_type_id,
            invoice_prefix,
            is_supplier
        } = this.state

        serverMutation({variables: {data: {client_id, name, client_type_id, invoice_prefix, is_supplier}}})
            .then(({data}) => {
                localMutation({variables: {data: data.updateClient}})
            })

    }


    render() {

        const {name, client_type_id, invoice_prefix, is_supplier} = this.state

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <Mutation mutation={updateClientMutation}>
                        {(updateClientMutationFunc, {loading}) => (
                            <AvForm
                                onValidSubmit={() => {
                                    const {
                                        client_id,
                                        name,
                                        client_type_id,
                                        is_supplier
                                    } = this.state

                                    updateClientMutationFunc({variables: {data: {client_id, name, client_type_id, invoice_prefix, is_supplier}}})
                                        .then(({data}) => {
                                            editProjectLocalMutationFunc({variables: {data: data.updateClient}})
                                            toast.success('Client Details Updated', {autoClose: 2000})
                                        })
                                        .catch(e => toast.error(e.message, {autoClose: false}))
                                }}
                            >
                                <Row form>
                                    <Col>
                                        <AvField
                                            required
                                            label="Name*"
                                            type="text"
                                            name="name"
                                            id="name"
                                            placeholder="Name"
                                            className="form-control-sm"
                                            value={name}
                                            onChange={(evt) => {
                                                const name = evt.target.value
                                                /*this.setState({name}, () => {
                                                    this.save({
                                                        ...this.state,
                                                        name
                                                    }, updateClientMutationFunc, editProjectLocalMutationFunc)
                                                })*/
                                                this.setState({name})
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                            <AUSelectClientTypes
                                                required
                                                label="Client Type*"
                                                name="client_type_id"
                                                value={client_type_id}
                                                className="form-control-sm"
                                                onChange={(client_type_id) => {
                                                    /*this.setState({client_type_id}, () => {
                                                        this.save({
                                                            ...this.state,
                                                            client_type_id
                                                        }, updateClientMutationFunc, editProjectLocalMutationFunc)
                                                    })*/
                                                    this.setState({client_type_id})
                                                }}
                                            />
                                    </Col>

                                    <Col>
                                        <AvField
                                            required
                                            label="Invoice Prefix"
                                            type="text"
                                            name="invoice_prefix"
                                            id="invoice_prefix"
                                            className="form-control-sm"
                                            value={invoice_prefix}
                                            onChange={(evt) => {
                                                const invoice_prefix = evt.target.value
                                                /*this.setState({name}, () => {
                                                    this.save({
                                                        ...this.state,
                                                        name
                                                    }, updateClientMutationFunc, editProjectLocalMutationFunc)
                                                })*/
                                                this.setState({invoice_prefix})
                                            }}
                                        />
                                    </Col>

                                </Row>

                                <Row form>
                                    <Col>
                                        <AvField
                                            label="Is Supplier"
                                            type="checkbox"
                                            name="is_supplier"
                                            id="is_supplier"
                                            value={is_supplier}
                                            onChange={(evt) => {
                                                const is_supplier = evt.target.checked
                                                /*this.setState({name}, () => {
                                                    this.save({
                                                        ...this.state,
                                                        name
                                                    }, updateClientMutationFunc, editProjectLocalMutationFunc)
                                                })*/
                                                this.setState({is_supplier})
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                                    <Button
                                        size="sm"
                                        color="success"
                                        disabled={loading}
                                    >
                                        <FontAwesomeIcon
                                            color="#fff"
                                            icon={loading ? 'spinner' : 'save'}
                                            spin={loading}
                                        />{' '}
                                        {loading ? 'Saving...' : 'Save Client'}
                                    </Button>
                                </div>
                            </AvForm>
                        )}
                    </Mutation>)}

            </Mutation>
        )
    }

}

ClientDetailForm.propTypes = {
    client: PropTypes.object.isRequired
}

export default ClientDetailForm